module.exports = __webpack_public_path__ + "img/9788962800258.29ca3072.jpg";